import React from 'react'
import {withRouter, Link} from 'react-router-dom'
import classNames from 'classnames'

// State
import {useSelector, useDispatch} from 'react-redux'
import appSlice from '../../store/slices/aplications'

// Components
import {Icon} from 'semantic-ui-react'
import styles from './styles.module.scss'
import lineageIcon from '../../styles/network.png'

function TopBarLeft({ history, match}) {

  const dispatch = useDispatch()

  const {openApps, currentAppId} = useSelector(state => state.applications)

  const handleBackBtn = () => {
    dispatch(appSlice.actions.setCurrentApp(null))
    history.push('/applications')
  }

  const handleAddDialog = () => dispatch(appSlice.actions.setDialogVisibility(true))

  const handleOpenApp = app => {
    if (currentAppId !== app.id) {
      dispatch(appSlice.actions.openApplication(app))
      history.push(`/applications/${app.id}`)
    }
  }

  const handleCloseApp = app => dispatch(appSlice.actions.closeApplication(app))


  if (match.url.includes('applications')) {

    return (
      <>

        { ( openApps.length > 0 && match.url !== '/applications') && (

          <>

            <Icon
              name="arrow left"
              onClick={handleBackBtn}
              className={classNames(styles.btn, styles.iconLeft)}
            />


            { openApps.map( app => {
              return (
                <div
                  key={`app-top-list-${app.id}`}
                  className={classNames(styles.tab, {[styles.tabOpened]: app.id === currentAppId })}
                >
                  <div onClick={() => handleOpenApp(app)}>
                    {app.name}
                  </div>

                  { app.id === currentAppId && (
                    <Icon
                      name="close"
                      size="small"
                      className={styles.closeBtn}
                      onClick={() => handleCloseApp(app)}
                    />
                  )}

                </div>

              )
            })}

          </>

        )}
        <Link to={"/gojs/data-lineage/graph.html"} target="diagram">
          {/*<Icon
            name="braille"
            size={"large"}
            //onClick={handleAddDialog}
            className={styles.btn}
          />*/}
          <img alt={"Link to data lineage"} src={lineageIcon} className={styles.lineageIcon}/>
        </Link>
        {/*<Link to={"/glossary"} target="newtabname">
          <Icon
            name="plus"
            //onClick={handleAddDialog}
            className={styles.btn}
          />
        </Link>*/}

      </>
    )
  }
  else if (match.url.includes('endpoint')) {
    return <Link to={"/gojs/data-lineage/graph.html"} target="diagram">
      <img alt={"Link to data lineage"} src={lineageIcon} className={styles.lineageIcon}/>
    </Link>
  }

  return false

}

export default withRouter(TopBarLeft)